@if (data) {
  <div>
    @for (item of data; track item) {
      <div>
        <app-legend-item [item]="item"></app-legend-item>
      </div>
    }
  </div>
}